import * as React from 'react';
import * as ImmutablePropTypes from 'react-immutable-proptypes';
import { Flex, Box } from 'grid-styled';

import RaisedButton from 'material-ui/RaisedButton';
import NewsLetterConfirmationDialog from './NewsLetterConfirmationDialog';
import DialogWrapper from '../../../_common/DialogWrapper/DialogWrapper';
import TextInputValidator from '../../../_common/Validator/TextInputValidator';
import { NewsletterFormRecord } from './NewsletterFormUtility';

import { trackUserOptIn } from '../../../../utils/tracking';

import { showInputErrorsType } from '../../../../utils/validation/errorMessages';

import { formatFormFieldsForMutation } from '../../../../utils/forms';
import EmailSignupMutation from '../../../../mutationsModern/Forms/EmailSignupMutation';

interface NewsletterFormProps {
  containerWidth: number;
  multiRow?: boolean;
  environment: Object;
  user: Object;
}

interface NewsletterFormState {
  form: ImmutablePropTypes.record;
  formErrors: ImmutablePropTypes.record;
  showErrors: showInputErrorsType;
  isDialogOpen: boolean;
}

export class NewsletterForm extends React.Component<
  NewsletterFormProps,
  NewsletterFormState
> {
  constructor(props: NewsletterFormProps) {
    super(props);

    this.state = this.getInitialState();
  }

  getInitialState = () => {
    return {
      form: new NewsletterFormRecord(),
      formErrors: new NewsletterFormRecord(),
      showErrors: {},
      isDialogOpen: false,
    };
  };

  openDialog = () => {
    this.setState({
      isDialogOpen: true,
    });
  };

  closeDialog = () => {
    const state = this.getInitialState();
    this.setState(state);
  };

  handleClick = () => {
    const { form, formErrors } = this.state;
    const { user, environment } = this.props;

    const formLayout = [{ fieldType: 'input', id: 'email' }];
    const formRequest = form.toJS();
    const validatorData = {
      email: {
        componentType: 'TextInput',
        validators: ['required', 'email'],
        floatingLabelText: 'Email Address*',
        hintText: 'email@address.com',
        name: 'email',
      },
    };

    const formFields = formatFormFieldsForMutation(
      formLayout,
      formRequest,
      validatorData,
    );

    if (form.email) {
      EmailSignupMutation.commit({
        environment,
        formFields,
        onCompleted: (response: Object, errors?: Array<Object>) => {
          if (!errors && !formErrors.email && form.email) {
            trackUserOptIn(form.email, user, 'Newsletter');
            this.openDialog();
          }
        },
        onError: () => console.log('Failed to sign up'),
      });
    }
  };

  getUpdatedShowErrorsDict = (
    showErrors: showInputErrorsType,
    id: string,
    showError: boolean,
  ): showInputErrorsType => {
    const showErrorsUpdated = { ...showErrors };
    showErrorsUpdated[id] = showError;
    return showErrorsUpdated;
  };

  onChange = (id: string, value: string): void => {
    this.setState(prevState => {
      const { form } = prevState;
      const updatedForm = form.set(id, value);
      const newState = {
        form: updatedForm,
        showErrors: this.getUpdatedShowErrorsDict(
          prevState.showErrors,
          id,
          false,
        ),
      };

      return newState;
    });
  };

  onValidate = (id: string, errorEnum: string): void => {
    this.setState(state => {
      const { formErrors } = state;
      const updatedFormErrors = formErrors.set(id, errorEnum);
      return { formErrors: updatedFormErrors };
    });
  };

  onBlur = (id: string) => {
    this.setState(state => {
      const showErrors = this.getUpdatedShowErrorsDict(
        state.showErrors,
        id,
        true,
      );
      return {
        showErrors,
      };
    });
  };

  render() {
    const { containerWidth, multiRow } = this.props;
    const { form, formErrors, isDialogOpen, showErrors } = this.state;

    const buttonStyles = {
      style: {
        margin: multiRow ? '8px 0 0 0' : '0 0 0 24px',
        borderRadius: 25,
      },
      buttonStyle: {
        fontFamily: 'Gotham A, Gotham B, sans-serif',
        borderRadius: 25,
      },
      labelStyle: {
        fontSize: '15px',
        paddingLeft: '50px', // check this too
        paddingRight: '50px',
      },
    };

    const style = {
      maxWidth: 400,
    };

    const boxStyle = {
      /**
       * maxHeight is calculated from the input box. the height is set to 38px, with 2px borders,
       * and a margin bottom 12px (38 + 2 + 2 + 12 = 52).
       *
       * this is so that the error message doesn't push the rest of the content around
       * whe it shows up.
       */
      maxHeight: 52,
    };

    const label = 'GO';
    const hintText = 'enter email';
    const email = 'email';

    return (
      <Flex className="NewsletterForm" column={multiRow} style={style}>
        <Box style={boxStyle} w={1}>
          <TextInputValidator
            boxWidth={[1]}
            componentType="TextInput"
            errorEnum={formErrors.get(email)}
            hintText={hintText}
            id={email}
            name={email}
            input={form.get(email)}
            onBlur={this.onBlur}
            onChange={this.onChange}
            onValidate={this.onValidate}
            showError={showErrors.email}
            validators={['email']}
          />
        </Box>

        <Box>
          <RaisedButton
            onClick={this.handleClick}
            label={label}
            labelStyle={buttonStyles.labelStyle}
            buttonStyle={buttonStyles.buttonStyle}
            style={buttonStyles.style}
          />
        </Box>

        <DialogWrapper isDialogOpen={isDialogOpen}>
          <NewsLetterConfirmationDialog
            containerWidth={containerWidth}
            closeDialog={this.closeDialog}
            isDialogOpen={isDialogOpen}
          />
        </DialogWrapper>
      </Flex>
    );
  }
}
